import { AccountData, ThemeType } from "@markit/common.types";
import ProfilePic from "../../ProfilePic";
import { addAlpha, Colors } from "../../../utils/colors";
import { useTheme } from "../../../hooks/useTheme";

type MiniProfileItemProps = {
  item: AccountData;
  onItemPress: () => void;
  rightIcon?: JSX.Element;
  hideModeLabel?: boolean;
  themeType: ThemeType;
};

const MiniProfileItem = ({
  item,
  onItemPress,
  rightIcon,
  themeType,
  hideModeLabel,
}: MiniProfileItemProps) => {
  const { theme } = useTheme(themeType);

  return (
    <div
      key={item.uid}
      className="AlignedRowSpacedSelect"
      onClick={onItemPress}
      style={{ borderRadius: 12, gap: 10 }}
    >
      <div className="AlignedRow" style={{ gap: 7, flex: 1, minWidth: 0 }}>
        <div>
          <ProfilePic user={item} size={20} forcePointer />
        </div>
        <div className="ColumnNormal" style={{ gap: 4, minWidth: 0 }}>
          <div className="ColumnNormal" style={{ gap: 2 }}>
            <span className="bodySmallMedium" style={theme.PrimaryText}>
              {item.fullName || "No Name"}
            </span>
            <span
              className="smallBodySubtext TextOverflowEllipsis"
              style={{ fontSize: 10 }}
            >
              {item.phoneNumber || item.email}
            </span>
          </div>
          {!hideModeLabel ? (
            <div
              className="RowNormal"
              style={{
                backgroundColor: item.email
                  ? addAlpha(Colors.BLUE5, 0.1)
                  : theme.NewPrimaryBG.backgroundColor,
                border: item.email
                  ? `0.5px solid ${Colors.BLUE5}`
                  : `0.5px solid ${theme.EditableTextFieldBorder.borderColor}`,
                paddingInline: 6,
                paddingBlock: 4,
                borderRadius: 100,
                alignSelf: "flex-start",
              }}
            >
              <span style={{ fontSize: 8, ...theme.PrimaryText }}>
                {item.email ? "Creator" : "Subscriber"}
              </span>
            </div>
          ) : undefined}
        </div>
      </div>
      {rightIcon}
    </div>
  );
};

export default MiniProfileItem;
